export default __webpack_public_path__ + "static/media/nav_img.eb65bf96.png";